import { ILeague } from "core-integration/src/store/leagues/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../Button";

const TeamLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  padding-top: ${({ theme }) => theme.space[3]};
`;

const TeamBadge = styled.img`
  display: block;
  width: 40px;
  height: 40px;
`;

interface IOwnProps {
  league: ILeague;
}

function localizeSplTeamPageUrl(
  urlString: string,
  language?: string | null,
): string {
  const locale = language?.toLowerCase().startsWith("ar") ? "ar" : "en";
  return urlString.replace(/\/(en|ar)\//, `/${locale}/`);
}

const TeamPageLink: React.FC<IOwnProps> = ({ league }) => {
  const { t, i18n } = useTranslation();
  const teamsById = useSelector(getTeamsById);

  if (league.league_type !== "s") return null;

  const team = Object.values(teamsById).find((t) => t.name === league.name);
  const link = team?.link_url
    ? localizeSplTeamPageUrl(
        team.link_url,
        i18n.resolvedLanguage ?? i18n.language,
      )
    : null;

  if (!link || !team) return null;

  return (
    <TeamLinkWrapper>
      <Button
        as="a"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        variant="primary"
      >
        {t("leagues.linkToTeamPage", "Team Page")}
      </Button>
      <TeamBadge
        src={`/img/badges/badge_${team.code}.png`}
        alt={t(
          "elementDialog.tabs.summary.teamBadgeAlt",
          "Football club badge for {{name}}",
          { name: team.name },
        )}
      />
    </TeamLinkWrapper>
  );
};

export default TeamPageLink;
